import React, { useEffect, useState, useRef } from 'react';
//import logo from './Resources/meic-logo-color.png';
import logo from './Resources/meicNuevo.png';
import logo_blanco from './Resources/meic-logo-blanco.png';
import logo_ice from './Resources/kolbi.png';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Alert from 'react-bootstrap/Alert';
import ReCAPTCHA from "react-google-recaptcha";
import { BlockUI } from 'primereact/blockui';
import { Dialog } from 'primereact/dialog';
import { Tooltip } from 'primereact/tooltip';
import { Toast } from 'primereact/toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useForm } from 'react-hook-form';
import { getProvincias, getCantones, getProductos, getDistritos, getEstudioActivo, getPrecios, getPreciosCompuesta, getPresentaciones, getMsjQuinPdcs } from './Requests';
import {
	Button,
} from './style';
import { faCircleInfo, faGlobe, faQuestion } from '@fortawesome/free-solid-svg-icons';
import {faFacebook, faInstagram, faTwitter, faYoutube} from '@fortawesome/free-brands-svg-icons';
import "primereact/resources/themes/lara-light-indigo/theme.css";  //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css"; 
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

function App() {

		
	const [blockedDocument, setBlockedDocument] = useState(false);
	const [respuesta, setRespuesta] = useState(false);

	const captcha = useRef(null);
	const [captchaValido, cambiarCaptchaValido] = useState(null);

	const [provincia, setProvincias] = useState([]);
	const [canton, setCantones] = useState([]);
	const [distrito, setDistritos] = useState([]);
	const [producto, setProductos] = useState([]);
	const [presentacion, setPresentacion] = useState([]);
	const [precio, setPrecio] = useState([]);
	const [precioXCom, setPrecioXCom] = useState([]);
	const [listaProds, setListaProds] = useState([]);
	const [estudio, setEstudio] = useState([]);
	const [pcsMsg, setPcsMsg] = useState([]);
	const [msgInfo, setMsgInfo] = useState("");
	const [visibleDialog, setVisibleDialog] = useState(false);
	const [mostrarListaProd, setMostrarListaProd] = useState(false);

	const [errorRequest, setErrorRequest] = useState(false);
	const { register, watch } = useForm();
	const [isValidProv, setIsValidProv] = useState(true); //muestra alerta validacion
	const [isValidCant, setIsValidCant] = useState(true); //muestra alerta validacion
	const [isValidProd, setIsValidProd] = useState(true); //muestra alerta validacion
	const [isValidPresent, setIsValidPresent] = useState(true); //muestra alerta validacion
	const [errorValidMsgProv, setErrorValidMsgProv] = useState(""); 
	const [errorValidMsgCant, setErrorValidMsgCant] = useState(""); 
	const [errorValidMsgProd, setErrorValidMsgProd] = useState(""); 
	const [errorValidMsgPresent, setErrorValidMsgPresent] = useState(""); 

	let watchProvincia = watch('idProvincia');
	let watchCanton = watch('idCanton');
	let watchDistrito = watch('idDistrito');

	let watchProducto = watch('idProducto');
	let idProducto = parseInt(watch('idProducto'), 10);
	const productoSeleccionado = producto.find(p => p.idProducto === idProducto);
	const nombreProducto = productoSeleccionado?.nombre || '';

	let watchPresentacion = watch('idPresentacion');
	let idPresentacion = parseInt(watch('idPresentacion'), 10);
	const presentacionSeleccionado = presentacion.find(p => p.idPresentacion === idPresentacion);
	const nombrePresentacion = presentacionSeleccionado?.tamano +" "+ presentacionSeleccionado?.unidad;

	const toast = useRef(null);

	const [visible, setVisible] = useState(false);
	const [datoSeleccionado, setDatoSeleccionado] = useState(null);

	const [mostrarTablaSimple, setMostrarTablaSimple] = useState(false);
	const [mostrarTablaCompuesta, setMostrarTablaCompuesta] = useState(false);

	const headerTemplate = (data) => {
		if(data.producto == "Grupo de los 15"){
			return (
				<React.Fragment >
					<b><span className="image-text"> {data.producto}</span></b>    
					<a style={{marginLeft: 10+'px'}} onClick={infoGrupo15} title="Información">
						<FontAwesomeIcon  icon={faCircleInfo}/>
					</a>
				</React.Fragment>

				);
		}else{
			return (
				<React.Fragment >
					<b><span className="image-text"> {data.producto} {data.tamano} {data.unidad}</span></b>                
				</React.Fragment>

				);
		}       
    }

	const infoGrupo15 = () =>{
		setVisibleDialog(true);
	}

	const onHideDialog = (name) => {
        setVisibleDialog(false);
    }

	const plantillaPrecio = (dato) => {
        return (dato.precio).toLocaleString('es-CR', { style: 'currency', currency: 'CRC' });
    }

	const plantillaPrecioAcum = (dato) => {
        //return (dato.precioAcumulado).toLocaleString('es-CR', { style: 'currency', currency: 'CRC' });
		return (
            <div className="flex align-items-center gap-2">                
                <span>
					{(dato.precioAcumulado).toLocaleString('es-CR', { style: 'currency', currency: 'CRC' })}
				</span>
            	<Tooltip target=".icon-search" content="Ver detalle" position="top" />
				<i className="pi pi-search icon-search" 
					style={{ fontSize: '1.5rem', color: '#7DB439', verticalAlign: 'middle', marginLeft: '1rem', cursor: 'pointer', transition: 'transform 0.3s ease, color 0.3s ease'}}
					
				onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
				onClick={() => {
					setDatoSeleccionado(dato);
					setVisible(true);}}>
				</i>
            </div>
        );
    }

	const validarCamposCompuesta= () => {
		var todoBien = true;
		if (watchProvincia === ""){
			setIsValidProv(false);
			setErrorValidMsgProv("Seleccione una provincia");
			todoBien = false;
		}
		if (watchCanton === ""){
			setIsValidCant(false);
			setErrorValidMsgCant("Seleccion un cantón");
			todoBien = false;
		}
		return todoBien;
	}

	const validarCampos = () => {
		var todoBien = true;
		if (watchProvincia === ""){
			setIsValidProv(false);
			setErrorValidMsgProv("Seleccione una provincia");
			todoBien = false;
		}
		if (watchCanton === ""){
			setIsValidCant(false);
			setErrorValidMsgCant("Seleccion un cantón");
			todoBien = false;
		}
		if (watchProducto === ""){
			setIsValidProd(false);
			setErrorValidMsgProd("Seleccione un producto");
			todoBien = false;
		}
		if (watchPresentacion === ""){
			setIsValidPresent(false);
			setErrorValidMsgPresent("Seleccione una presentación");
			todoBien = false;
		}
		return todoBien;
	}

	const validarProds = () => {
		var todoBien = true;
		if (watchProducto === ""){
			setIsValidProd(false);
			setErrorValidMsgProd("Seleccione un producto");
			todoBien = false;
		}
		if (watchPresentacion === ""){
			setIsValidPresent(false);
			setErrorValidMsgPresent("Seleccione una presentación");
			todoBien = false;
		}
		return todoBien;
	}

	async function addProduct() {
		if (validarProds()) {
			// Validar límite de 15 productos
			if (listaProds.length >= 15) {
				toast.current.show({
					severity: 'error', // rojo (equivalente a danger)
					summary: 'Límite alcanzado',
					detail: 'No se pueden agregar más de 15 productos.',
					life: 4000
				});
				return;
			}

			const nuevaFila = {
				idProducto: watchProducto,
				producto: nombreProducto,
				idPresentacion: watchPresentacion,
				presentacion: nombrePresentacion
			};

			// Validar duplicados
			const existe = listaProds.some(
			item =>
				item.idProducto === nuevaFila.idProducto &&
				item.idPresentacion === nuevaFila.idPresentacion
			);

			if (existe) {
			toast.current.show({
				severity: 'error',
				summary: 'Duplicado',
				detail: 'El producto y presentación seleccionados ya están en la lista.',
				life: 4000
			});
			return;
			}

			// Agregar producto
			setListaProds(prev => [...prev, nuevaFila]);
			setMostrarListaProd(true);

		}
	}

	async function process() {
		
		if(captcha.current.getValue()){
			setMostrarTablaSimple(false);
			setMostrarTablaCompuesta(false);
			if(listaProds.length === 0){
				if (validarCampos()){
					setBlockedDocument(true);
					var idEstudioActivo = "1";

					estudio.map((value) => (
						idEstudioActivo = value.elEstudio.idEstudio
					)) 
					
					const response = await getPrecios(watchProvincia, watchCanton, watchDistrito,
						watchProducto, watchPresentacion, idEstudioActivo, captcha.current.getValue());
					response.errors ? setErrorRequest(true) : setPrecio(response);
					//console.log(response)
					cambiarCaptchaValido(true);
					setBlockedDocument(false);
					window.grecaptcha.reset();

					setMostrarTablaSimple(true);
				}else{
					return;
				}
			}else{
				if (validarCamposCompuesta()){
					setBlockedDocument(true);
					var idEstudioActivo = "1";

					estudio.map((value) => (
						idEstudioActivo = value.elEstudio.idEstudio
					)) 
					
					const response = await getPreciosCompuesta(watchProvincia, watchCanton, idEstudioActivo, listaProds, captcha.current.getValue());
					response.errors ? setErrorRequest(true) : setPrecioXCom(response);
					console.log(response)
					cambiarCaptchaValido(true);
					setBlockedDocument(false);
					window.grecaptcha.reset();
					setMostrarTablaCompuesta(true);
				}else{
					return;
				}
			}

		}else{
			cambiarCaptchaValido(false);
		}
	}

	useEffect(() => {
		async function fetchInitialData() {
			
			setRespuesta(false);

			const response = await getProvincias();
			if(typeof response != 'string'){
				response.errors ? setErrorRequest(true) : setProvincias(response);
			}
			

			const responsePcts = await getProductos();
			if(typeof responsePcts != 'string'){
				responsePcts.errors ? setErrorRequest(true) : setProductos(responsePcts);
			}
			

			//const responsePres = await getPresentacion();
			//responsePres.errors ? setErrorRequest(true) : setPresentacion(responsePres);
			
			const responseEst = await getEstudioActivo();
			if(typeof responseEst != 'string'){
				responseEst.errors ? setErrorRequest(true) : setEstudio(responseEst);
			}
			

			//const responseMsg15 = await getMsjQuinPdcs();
			//responseMsg15.errors ? setMsgInfo("") : setMsgInfo(
			//	responseMsg15.map((value) => (
			//		//value.periodo
			//		<div><p>El grupo de los 15 esta compuesto por:</p><ul><li>Arroz grano entero 80% - 1 Kg</li><li>Frijoles negros o rojos primera calidad - 1 Kg</li><li>Atún trocitos de lomo en aceite - 100 g</li><li>Aceite de soya - 1 L</li><li>Manteca - 500 g</li><li>Sal regular - 500 g</li><li>Azúcar regular blanca - 1 Kg</li><li>Pastas alimenticias, tipo lengua o espagueti - 250 g</li><li>Harina de trigo - 1 Kg</li><li>Harina de maíz blanco - 1 Kg</li><li>Tortillas de maíz - 10 unidades</li><li>Café molido con azúcar - 250 g</li><li>Leche fresca corta duración semidescremada 2% grasa - 1 L</li><li>Leche en polvo semidescremada - 360 G</li><li>Leche en polvo entera - 500 g</li></ul></div>
			//	))  
			//);

			setPcsMsg(["32"]);
		}

		fetchInitialData();
	}, []);

	useEffect(() => {
		//setLoading(true);  // here loading is true
		setCantones([]);

		var idEstudioActivo = "1";

		estudio.map((value) => (
			idEstudioActivo = value.elEstudio.idEstudio
		)) 
		async function fetchCantones() {
			const response = await getCantones(watchProvincia, idEstudioActivo);
			response.errors ? setErrorRequest(true) : setCantones(response);
		}
		if (watchProvincia) {
			fetchCantones();
		}
	}, [watchProvincia]);

	useEffect(() => {
		setDistritos([]);
		async function fetchDistritos() {
			const response = await getDistritos(watchCanton);
			response.errors ? setErrorRequest(true) : setDistritos(response);
		}
		if (watchCanton) {
			fetchDistritos();
		}
	}, [watchCanton]);

	useEffect(() => {
		setPresentacion([]);
		async function fetchPresntaciones() {
		/*	if (pcsMsg.includes(watchProducto)){
				setVisibleDialog(true);
			}*/
			const response = await getPresentaciones(watchProducto);
			response.errors ? setErrorRequest(true) : setPresentacion(response);
		}
		if (watchProducto) {
			fetchPresntaciones();
		}
	}, [watchProducto]);
	
	useEffect(() => {
		async function fetchLimpiaProductos() {
			if (listaProds.length > 0) {
				setProductos([]);
				const responsePcts = await getProductos();
				if(typeof responsePcts != 'string'){
					responsePcts.errors ? setErrorRequest(true) : setProductos(responsePcts);
				}
			}
		}
		fetchLimpiaProductos();
	}, [listaProds]); // Se ejecuta cada vez que listaProds cambia

	/*if (loading) return
    return (
        <Spinner animation="border" variant="primary" />
    );*/

	const onChange = () => {
		cambiarCaptchaValido(true);
	}

	const cambiaProvincia = () =>{
		setIsValidProv(true);
		setErrorValidMsgProv("");
		window.grecaptcha.reset();
	}

	const cambiaCanton = () =>{
		setIsValidCant(true);
		setErrorValidMsgCant("");
		window.grecaptcha.reset();
	}

	const cambiaProducto = () =>{
		setIsValidProd(true);
		setErrorValidMsgProd("");
		window.grecaptcha.reset();
	}

	const cambiaPresentacion = () =>{
		setIsValidPresent(true);
		setErrorValidMsgPresent("");
		window.grecaptcha.reset();
	}

	const eliminarFila = (fila) => {
		setListaProds((prev) => prev.filter(item => item !== fila));
		console.log(listaProds.length)
		if(listaProds.length === 1){
			console.log(listaProds)
			console.log("La lista quedo vacia")
			setMostrarListaProd(false);
		}
	};


	return (
		<div className="blockui-demo gris-fondo">
			<div className='cuerpo gris-fondo'>

			{blockedDocument && (
				<BlockUI blocked={blockedDocument} fullScreen>
					<div style={{
						position: 'fixed',      // se mantiene fijo en la pantalla
						top: '50%',             // lo coloca en el centro vertical
						left: '50%',            // lo coloca en el centro horizontal
						transform: 'translate(-50%, -50%)', // ajusta el punto de referencia
						backgroundColor: 'rgba(255, 255, 255, 0.9)', // opcional: fondo semitransparente
						padding: '20px',
						borderRadius: '8px',
						boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
						zIndex: 9999,           // asegura que esté encima de todo
						textAlign: 'center'
					}}>
						<i className="pi pi-spin pi-spinner" style={{ fontSize: '3rem', color: '#7DB439' }}></i>
						<p style={{ fontSize: '1.2rem', marginTop: '1rem' }}>Procesando consulta...</p>
					</div>

				</BlockUI>
			)}
				
					<nav className='head-arriba navbar'>
						<a className='imagen-meic'>
							<img src={logo} alt="Logo MEIC" width="500" className='mostrarPequeño'/>
							
						</a>
						<div className=''>
							<h1 className='titulo'> Precios de Canasta Básica</h1>
						</div>
					</nav>
					<br/>
					<div className='container'>
							<Form.Label className='label-estudio' htmlFor="idProvincia">
							Precios basados en estudio realizado {
										estudio.map((value) => (
											value.periodo
										))  
									} 
							</Form.Label>
							<br/><br/>
							<Row className="mb-3">
								<Form.Group as={Col} className='col-12 col-md'>
									<Form.Label className='label-meic' htmlFor="idProvincia">Provincia</Form.Label>
									<Form.Label className='label-ast' >*</Form.Label>
									<Form.Select  name="idProvincia" ref={register()} onChange={cambiaProvincia}>
										<option value="">-- SELECCIONE --</option>=
										{provincia.map((value) => (
											<option value={value.idProvincia} key={value.idProvincia}>
												{value.nombre}
											</option>
										))}
									</Form.Select >
									{isValidProv 
										? <br/>
										: <Alert id='msjProv' variant="danger" onClose={() => setIsValidProv(true)} dismissible>
											{ errorValidMsgProv }
										</Alert>
									}
								</Form.Group>
								<Form.Group as={Col} className='col-12 col-md'>
									<Form.Label className='label-meic' htmlFor="idCanton">Cantón</Form.Label>
									<Form.Label className='label-ast' >*</Form.Label>
									<Form.Select name="idCanton" ref={register()} onChange={cambiaCanton}>
										<option value="">-- SELECCIONE --</option>
										{canton.map((value) => (
											<option value={value.cantonPK.idCanton} key={value.cantonPK.idCanton}>
												{value.nombre}
											</option>
										))}
									</Form.Select>
									{isValidCant 
										? <br/>
										: <Alert id='msjCant' variant="danger" onClose={() => setIsValidCant(true)} dismissible>
											{ errorValidMsgCant }
										</Alert>
									}
								</Form.Group>
							</Row>
							<Row >
								<Form.Group as={Col} className='col-12 col-md'>
									<Form.Label className='label-meic' htmlFor="idProducto">Producto</Form.Label>
									<Form.Label className='label-ast' >*</Form.Label>
									<Form.Select name="idProducto" ref={register()} onChange={cambiaProducto}>
										<option value="">-- SELECCIONE --</option>
										{producto.map((value) => (
											<option value={value.idProducto} key={value.idProducto}>
												{value.nombre}
											</option>
										))}
									</Form.Select>
									{isValidProd 
										? <br/>
										: <Alert id='msjProv' variant="danger" onClose={() => setIsValidProd(true)} dismissible>
											{ errorValidMsgProd }
										</Alert>
									}
								</Form.Group>
								<Form.Group as={Col} className='col-12 col-md'>
									<Form.Label className='label-meic' htmlFor="idPresentacion">Presentación</Form.Label>
									<Form.Label className='label-ast' >*</Form.Label>
									<Form.Select name="idPresentacion" ref={register()} onChange={cambiaPresentacion}>
										<option value="">-- SELECCIONE --</option>
										{/*<option value="-123">-- TODAS --</option>*/}
										{presentacion.map((value) => (
											<option value={value.idPresentacion} key={value.idPresentacion}>
												{value.tamano + " " + value.unidad}
											</option>
										))}
									</Form.Select>
									{isValidPresent
										? <br/>
										: <Alert id='msjPresent' variant="danger" onClose={() => setIsValidPresent(true)} dismissible>
											{ errorValidMsgPresent }
										</Alert>
									}
								</Form.Group>

							</Row>
							<Form.Label style={{color: 'red', marginBottom: '3rem', fontWeight: 700}}>* Campos obligatorios</Form.Label>
							<Row>
								<Col md={3}>
									<Button onClick={addProduct} style={{fontWeight: 700}} className="mb-4 ">
										Agregar producto a la consulta
									</Button>
									
								</Col>
								<Col md={9}>
									<Toast ref={toast} position="center" />
									
									{mostrarListaProd && (
										 <div>
										<Form.Label style={{fontWeight: 700, display: 'block', marginBottom: '1rem'}}>
										El máximo de productos a consultar son 15.
											</Form.Label>
											<DataTable showGridlines  value={listaProds} stripedRows
												emptyMessage=" " responsiveLayout="stack">									
												<Column field="producto" header="Producto"/>
												<Column field="presentacion" header="Presentación"/>
												<Column
													header="Acciones"
													body={(rowData) => (
													<button
														className="btn btn-sm"
														onClick={() => eliminarFila(rowData)}
														style={{
															backgroundColor: '#28B5AE',
															borderColor: '#28B5AE',
															color: 'white'
														}}
													>
														Eliminar
													</button>
													)}
												/>

											</DataTable>
										</div>
										
									)}
								</Col>
							</Row>
							
							<ReCAPTCHA className="mt-4"
								ref={captcha}
								sitekey="6LcqXbwiAAAAAMCq9hc4EZWNt1CJvb_PoYZf4Slp"
								onChange={onChange}
							/>
							
							{captchaValido === false && <div className='error-captcha'>Por favor acepte el captcha</div>}
							
							<Button className="mt-3" onClick={process} style={{fontWeight: 700}}>
								Consultar
							</Button>
							<br/><br/>

							
							{mostrarTablaSimple && (
								<>

									<div className="card">
										<DataTable id="tablaBasica" showGridlines  value={precio} stripedRows  rowGroupMode="subheader" groupRowsBy="tamano"
											emptyMessage="No se encontraron resultados." rowGroupHeaderTemplate={headerTemplate}  responsiveLayout="stack">
											<Column  field="marca"  header="Marca"/>
											
											<Column field="comercio" header="Comercio"/>
											<Column field="provincia" header="Provincia"/>
											<Column field="canton" header="Cantón"/>
											<Column field="distrito" header="Distrito"/>
											<Column field="direccion" header="Dirección"/>
											<Column field="precio"  header="Precio" body={plantillaPrecio}/>
										</DataTable>		
									</div>
								</>
							)}
							<br/>
							{mostrarTablaCompuesta && (
								<>
									<Form.Label style={{fontWeight: 700, display: 'block', marginBottom: '1rem'}}>Resultados disponibles solo si el comercio incluye todos los productos.</Form.Label>
									<div className="card">
										<DataTable id="tablaCompuesta" showGridlines  value={precioXCom} stripedRows
											emptyMessage="No se encontraron comercios que incluyan todos los productos seleccionados." responsiveLayout="stack">
											<Column field="elComercio.nombre"  header="Comercio"/>
											<Column field="elComercio.distrito.nombre"  header="Distrito"/>
											<Column field="elComercio.direccion" header="Dirección"/>
											<Column field="precioAcumulado" header="Precio total" body={plantillaPrecioAcum} />
										</DataTable>		
									</div>
								</>
							)}

							<br/><br/>

							<br/><br/><br/><br/>
							
					</div>
					<div className='container-fluid fondo-azul'>
						<footer className='div-abajo fondo-azul'>
							<div className="row div-abajo" >
								<div className="col-12 col-md-6 text-center pt-4">
									<img src={logo_blanco} alt="Logo MEIC" width="700" className='img-fluid'/>
									
									<div className="col-12 col-xl-12 p-4">
										<a className="fa-lg fa-stack social-media-button" href="https://www.meic.go.cr/" target="_blank"  title="Sitio Web">
												<FontAwesomeIcon className='iconos' icon={faGlobe}/>
										</a>
										<a className="fa-lg fa-stack social-media-button" href="https://www.facebook.com/MEICCR" target="_blank" title="Facebook">
												<FontAwesomeIcon className='iconos' icon={faFacebook}/>
										</a>
										<a className="fa-lg fa-stack social-media-button" href="https://www.twitter.com/meic_crc" target="_blank" title="Twitter">
											<FontAwesomeIcon className='iconos' icon={faTwitter}/>
										</a>
										<a className="fa-lg fa-stack social-media-button" href="https://www.youtube.com/user/MEICCR" target="_blank" title="YouTube">
											<FontAwesomeIcon className='iconos' icon={faYoutube}/>
										</a>
									</div>
									
								</div>
								<div className="col-12 col-md-6 centrar pt-4"  >
									<img src={logo_ice} alt="Logo KOLBI" width="158" className='img-fluid'/>
									<br/><br/>
									<div className="col-12 col-xl-12  ">
										<a className="fa-lg fa-stack social-media-button" href="https://www.kolbi.cr/" target="_blank"  title="Sitio Web">
											<FontAwesomeIcon className='iconos' icon={faGlobe}/>
										</a>
										<a className="fa-lg fa-stack social-media-button" href="https://www.facebook.com/kolbicr" target="_blank" title="Facebook">
											<FontAwesomeIcon className='iconos' icon={faFacebook}/>
										</a>
										<a className="fa-lg fa-stack social-media-button" href="https://www.instagram.com/kolbi_cr" target="_blank" title="Instagram">
											<FontAwesomeIcon className='iconos' icon={faInstagram}/>
										</a>
										<a className="fa-lg fa-stack social-media-button" href="https://www.twitter.com/kolbi_cr" target="_blank" title="Twitter">
											<FontAwesomeIcon className='iconos' icon={faTwitter}/>
										</a>
										<a className="fa-lg fa-stack social-media-button" href="https://www.youtube.com/@kolbi_cr" target="_blank" title="YouTube">
											<FontAwesomeIcon className='iconos' icon={faYoutube}/>
										</a>
										
									</div>
								</div>
							</div>
							<div className='version'>05122025</div>
						</footer>
					</div>
					<Dialog header="Información" visible={visibleDialog} onHide={() => onHideDialog()}  breakpoints={{'960px': '75vw', '640px': '100vw'}} style={{width: '50vw'}}>
    					{msgInfo}
					</Dialog>
					<Dialog
						header="Detalle del Precio Total"
						visible={visible}
						style={{ width: '50vw' }}
						onHide={() => setVisible(false)}
						>
						
						{datoSeleccionado ? (
							
							<DataTable showGridlines  value={datoSeleccionado.listaPrecios} stripedRows responsiveLayout="stack">
								<Column field="producto.nombre" header="Producto" />
								<Column field="marca.descripcion" header="Marca" />
								<Column body={(rowData) => `${rowData.presentacion.tamano} ${rowData.presentacion.unidad}`} header="Presentacíón" />
								<Column field="precio" header="Precio unitario" body={plantillaPrecio}
										footer={
												datoSeleccionado.listaPrecios
													.reduce((acc, item) => acc + item.precio, 0)
													.toLocaleString('es-CR', { style: 'currency', currency: 'CRC' })
											}
								/>
							</DataTable>	


							
						) : (
							<p>No hay datos seleccionados</p>
						)}

					</Dialog>
					
			</div>
		</div>
	);
}

export default App;
